import { Outlet } from "react-router-dom";

export default function PromoLayout() {
  return (
    <div className="p-4 sm:p-6">
      <Outlet />
    </div>
  );
}
